import(/* webpackMode: "eager", webpackExports: ["Glass"] */ "/vercel/path0/app/_components/marketing/glass.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/_lib/assets/images/bg-lined.png");
;
import(/* webpackMode: "eager", webpackExports: ["CaseStudyStickyBar"] */ "/vercel/path0/app/(routes)/(header-and-footer)/portfolio/[slug]/components/sticky-bar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
